import * as React from 'react';
import { Link } from 'react-router-dom';
import { showLogInfo } from 'src/constants/profileSettings';


interface IProps {
  dismiss: (bool: showLogInfo) => void;
}

export const LogInfo: React.SFC<IProps> = props => {
  const dismissNotice = () => {
    props.dismiss(showLogInfo.false);
  }

  return (
    <div className="notification is-primary">
      {/* <button className="delete" /> */}
      <h1 className="title" >Notice</h1>
      Hey guys, we have to inform you, that while you use this page a few actions are logged to our servers. <br />
      This happens without any userdata, so don't worry about that. <Link to="/profilesettings">If you want to opt out of this, just go to the settings.</Link>
      <br/>
      <button className="button is-light is-outlined" onClick={dismissNotice}>Dismiss</button>
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/components/LogInformation/LogInfo.tsx